import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MenuSearchService {
  public searchQuery$ = new BehaviorSubject<string>('');
}
